import type { EvidenceSessionAIModel } from 'api';

export const EVIDENCE_SESSION_AI_MODEL_LABEL_MAP: Record<EvidenceSessionAIModel, string> = {
  alu: 'UBC Bale',
  alu_loose: 'UBC Loose',
  briquette: 'UBC Briquette',
  pet: 'PET Bale',
};
